import { render } from "./StepThree.vue?vue&type=template&id=0ed4f3fb&scoped=true"
import script from "./StepThree.vue?vue&type=script&lang=js"
export * from "./StepThree.vue?vue&type=script&lang=js"

import "./StepThree.vue?vue&type=style&index=0&id=0ed4f3fb&scoped=true&lang=css"

import exportComponent from "/Users/denis/Documents/Работа/bitbucket/mifab/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ed4f3fb"]])

export default __exports__